export enum QRCodeForms {
  UpdateQRCode = 'UpdateQRCode',
  CreateQRCode = 'CreateQRCode',
  DisableQRCode = 'DisableQRCode',
  LoadQRCode = 'LoadQRCode',
  SubmitFeedback = 'SubmitFeedback',
}
